const apiStringServer = 'https://kprocessos-old-server.kintelligence.com.br:3348';
//const apiStringServer = 'http://192.168.1.23:3348';

export default apiStringServer;